export default [
//   {
//     path: "/yunbuy",
//     name: "yunbuy",
//     meta: {
//       title: "购买云手机",
//     },
//     component: () => import("./YunBuy"),
//   },
//   {
//     path: "/yunproblem",
//     name: "yunproblem",
//     meta: {
//       title: "云手机常见问题",
//     },
//     component: () => import("./YunProblem"),
//   },
];
